import { render } from "./SetPrices.vue?vue&type=template&id=6a8a525d&scoped=true"
import script from "./SetPrices.vue?vue&type=script&lang=js"
export * from "./SetPrices.vue?vue&type=script&lang=js"

import "./SetPrices.vue?vue&type=style&index=0&id=6a8a525d&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8a525d"]])

export default __exports__